import BasicResultModel from "../../domain/model/basic_result_model";
import TierRepository from "../../domain/repository/tier_repository";
import { USER_ID_KEY } from "../../../core/constants/app_constants";

export default class TierRepositoryImpl extends TierRepository {
  static #instance = null;
  constructor(tierApiService, localStorageService, pricingSocketService) {
    if (TierRepositoryImpl.#instance) {
      return TierRepositoryImpl.#instance; // Return the same instance if already created
    }
    super(tierApiService, localStorageService, pricingSocketService);
    TierRepositoryImpl.#instance = this; // Store the instance
  }

  async getActiveTiers() {
    const result = await this.tierApiService.getActiveTiers();
    return result;
  }

  async subscribeTier({ tierId, userId, onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }) {
    this.pricingSocketService.connect({
      onConnected: async (socketid) => {
        const result = await this.tierApiService.subscribeTier({ tierId, userId, socketid });
        console.log("SUBSCRIBE TIER RESULT", result);
        if (!result.success) {
          onError(result.message);
          const errorType = result.error[0].type;
          if (errorType == "TIER_NO_BILLING_ADDRESS") {
            onNoBillingAddress();
          } else if (errorType == "TIER_NO_PAYMENT_METHOD") {
            onNoPaymentMethod();
          } else {
            onError(result.message);
          }
          this.pricingSocketService.disconnect();
        }
      },
      onDisconnected: () => {
        console.log("Disconnected from pricing socket");
        onDone();
      },
      onPaymentEvent: (data) => {
        console.log("Payment event receivedsssss:", data);
        if (data.data.status === "success") {
          onSuccess();
          this.pricingSocketService.disconnect();
        } else {
          onError("Failed to subscribe");
          this.pricingSocketService.disconnect();
        }
      },
      onError: (error) => {
        console.log("Error:", error);
        onError(error);
      },
    });
  }

  async unsubscribeTier(data) {
    const result = await this.tierApiService.unsubscribeTier(data);
    return new BasicResultModel(result.success, result.message);
  }

  async updateUserSubscription() {
    const userId = await this.localStorageService.getData(USER_ID_KEY);
    if (userId == null) {
      return new BasicResultModel(false, "User not found");
    }
    const result = await this.tierApiService.updateUserSubscription({ userId });
    return new BasicResultModel(result.success, result.message);
  }

  /// Currently, this function is only to validate the tierId on the payment page. If in future that you want to actually used it,
  /// you can add more functions to populate the tier details on the returned model.
  async getTierById(tierId) {
    const result = await this.tierApiService.getTierById(tierId);
    return new BasicResultModel(result.success, result.message);
  }

  async reactivateTier() {
    const userId = await this.localStorageService.getData(USER_ID_KEY);
    if (userId == null) {
      return new BasicResultModel(false, "User not found");
    }
    const result = await this.tierApiService.reactivateTier({ userId });
    return new BasicResultModel(result.success, result.message);
  }
}
